export default __webpack_public_path__ + "static/media/RTR 160 4V_1.d2014ea7.webp";